import { registerGtmDataLayer } from '../../../../../Features/Blocks/Video/gtmDataLayerService';
export default async function (body, url, formularInformation, antiForgeryToken, recaptchaToken) {
  let status = null
  const boolToYesNo = (value) => value == undefined
    ? "not_applicable"
    : value
      ? "Yes"
      : "No";

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      "RequestVerificationToken": antiForgeryToken,
      "RecaptchaToken": recaptchaToken
    },
  })
    .then((res) => {
      status = res.status
      if (res.ok) {
        return res.json()
      } else {
        throw new Error("Signup to get contacted didn't work")
      }
    })
    .then((res) => {
      return res
    })
    .catch((err) => {
      console.error(err)
      return err
    })

  if (response && response.name && response.email) {
    let dataLayer = {
      'event': 'track-immeo.leadform_submit',
      'form_id': formularInformation.formId,
      'form_name': formularInformation.formName,
      'form_type': 'userdata',
      'userExistingClient': boolToYesNo(body.isCustomer),
      'eventCategory': 'leadform',
      'eventAction': 'submit',
      'eventLabel': formularInformation.formName,
      'payload': {
        'user_firstname': response.name,
        'user_lastname': response.lastname,
        'user_email': response.email,
        'user_phone': response.phonenumber
      }
    };

    registerGtmDataLayer(dataLayer);
  }
  return {
    response: response,
    status: status,
  }
}
